import { CreateClient } from 'utils/apiClient';
import i18next from 'i18next';

export class API extends CreateClient {
  constructor (runtimeConfig) {
    // In development, use empty base URL so the dev proxy can intercept /api/* requests
    // In deployed environments, use the full API Gateway URL from config
    const baseUrl = process.env.NODE_ENV === 'development'
      ? ''
      : (runtimeConfig.REACT_APP_API_BASE_URL || '');
    
    super({
      baseUrl: baseUrl,
      showLog: process.env.NODE_ENV === 'development'
    })
    this.http.interceptors.request.use(config => {
      config.headers["Accept-Language"] = i18next.language;
      return config
    })
    this.http.interceptors.response.use(
      response => response.data,
      error => Promise.reject(error)
    )
  }

  static apiInstance = null;
  static CreateInstance(runtimeConfig) {
    this.apiInstance = new API(runtimeConfig);
  }

  static GetInstance(){
    return this.apiInstance;
  }
}


//export default API
